import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["noContainer", "templateId", "templateUid", "tracking", "trackEvent"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { onTrackItemClickEvent, trackingPropType } from "../../util/tracking";
import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useMainContext } from "../main-context";
import Typeform from "../common/typeform";
import { CTA_LABEL, TEMPLATE_URL_PARAMS } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
var TypeformTemplateModule = function TypeformTemplateModule(_ref) {
  var noContainer = _ref.noContainer,
    templateId = _ref.templateId,
    templateUid = _ref.templateUid,
    tracking = _ref.tracking,
    trackEvent = _ref.trackEvent,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useMainContext = useMainContext(),
    sharedVariables = _useMainContext.sharedVariables;
  var typeformTemplateUrl = useMemo(function () {
    return "https://admin.".concat(sharedVariables.TYPEFORM_ROOT_DOMAIN, "/form/template/").concat(templateId).concat(TEMPLATE_URL_PARAMS);
  }, [sharedVariables, templateId]);
  var onClickCta = useCallback(function () {
    var cta = {
      tracking: tracking,
      url: typeformTemplateUrl
    };
    onTrackItemClickEvent(cta, trackEvent);
  }, [tracking, typeformTemplateUrl, trackEvent]);
  if (!(templateId && templateUid)) return null;
  return /*#__PURE__*/_jsx(Typeform, _objectSpread({
    formId: templateId,
    onClick: onClickCta,
    text: CTA_LABEL,
    url: typeformTemplateUrl
  }, rest));
};
TypeformTemplateModule.displayName = 'TypeformTemplateModule';
TypeformTemplateModule.propTypes = {
  noContainer: PropTypes.bool,
  templateId: PropTypes.string.isRequired,
  templateUid: PropTypes.string.isRequired,
  tracking: trackingPropType,
  trackEvent: PropTypes.func,
  onReady: PropTypes.func,
  onSubmit: PropTypes.func,
  onQuestionChanged: PropTypes.func,
  inlineOnMobile: PropTypes.bool,
  standAlone: PropTypes.bool
};
TypeformTemplateModule.defaultProps = {
  noContainer: false,
  tracking: null,
  trackEvent: function trackEvent() {},
  onReady: undefined,
  onSubmit: undefined,
  onQuestionChanged: undefined,
  inlineOnMobile: false,
  standAlone: false
};
export default /*#__PURE__*/memo(TypeformTemplateModule);